import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import Alert from 'src/components/ui/Alert';

const MaterialTypeBlendingBlockedAlert = ({ actionLabel, className }) => (
  <Alert
    variant='danger'
    icon={faExclamationTriangle}
    title={`Cannot ${actionLabel}`}
    className={className}
  >
    This {actionLabel} is blocked because the batches contain different material types. Blending
    across different material types is not allowed for this bureau.
  </Alert>
);

MaterialTypeBlendingBlockedAlert.propTypes = {
  actionLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
};

MaterialTypeBlendingBlockedAlert.defaultProps = {
  className: 'mb-4',
};

export default MaterialTypeBlendingBlockedAlert;
